export function shouldFetchPolicies(state) {
  const policies = state.policies
  if (policies.items.length === 0) {
    return true
  }

  if (state.policies.isFetching) {
    return false
  }

  return false
}



// WEBPACK FOOTER //
// ./src/utils/policies.js